import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Slide, Box } from '@mui/material';
import { BsDashCircleFill } from "react-icons/bs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RDialog({ title = "Test", fullScreen = false, open = false, handleClose = () => { }, children }) {

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? '#1c1f24 !important' : '#ffffff !important',
                        backgroundImage: 'none !important',
                        opacity: '1 !important',
                        color: (theme) => theme.palette.mode === 'dark' ? '#ffffff' : '#111827',
                        borderRadius: fullScreen ? 0 : '16px',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.35) !important',
                        border: (theme) => theme.palette.mode === 'dark' ? '1px solid #2d3139' : '1px solid #e5e7eb',
                        overflow: 'hidden',
                    },
                    className: "text"
                }}
            >
                <Box display={'flex'} alignItems={'center'}
                    justifyContent={'space-between'}
                    sx={{
                        borderRadius: fullScreen ? 0 : '16px 16px 0 0',
                        px: { xs: 2, md: 4 },
                        py: 1.5,
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? '#242830 !important' : '#f8fafc !important',
                        borderBottom: (theme) => theme.palette.mode === 'dark' ? '1px solid #2d3139' : '1px solid #e2e8f0',
                        color: (theme) => theme.palette.mode === 'dark' ? '#ffffff' : '#0f172a',
                    }}
                >
                    <Typography fontSize={16} fontWeight={700} sx={{ letterSpacing: 0.5 }}>{title}</Typography>
                    <Box
                        onClick={handleClose}
                        sx={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: 22,
                            color: 'inherit',
                            opacity: 0.8,
                            transition: 'opacity 0.2s',
                            '&:hover': { opacity: 1 }
                        }}
                    >
                        <BsDashCircleFill />
                    </Box>
                </Box>
                <Box
                    sx={{
                        borderRadius: fullScreen ? 0 : '0 0 16px 16px',
                        p: { xs: 2, md: 3 },
                        flexGrow: 1,
                        overflowY: 'auto',
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? '#1c1f24 !important' : '#ffffff !important',
                        color: (theme) => theme.palette.mode === 'dark' ? '#ffffff' : '#111827',
                    }}
                    className="text"
                >
                    {children}
                </Box>
            </Dialog>
        </React.Fragment>
    );
}
